import { merge } from 'lodash-es';
import React from 'react';
import {
  GoogleMap,
  InfoWindow,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import { Link } from 'react-router-dom';
import Config from '../../app.config';
import { analytics, getStyles, slugGenerator } from '../../utils/common';
import { LocationContext } from './locations';

const getMapOptions = () => ({
  styles: getStyles(),
  disableDefaultUI: true,
  markerMethod: 'mouseover',
  backgroundColor: 'white',
});

const getInfo = location => (
  <LocationContext.Consumer>
    {({ handleLocationClick, purchaseFunnel }) => (
      <div className="locations-list-item locations-list-item--info-window">
        <h5 className="locations-list-item__title locations-list-item__title--info-window">
          {location.name}
        </h5>
        <div className="locations-list-item__address locations-list-item__address--info-window">
          <div className="locations-list-item__address-street">
            {location.address}
          </div>
          <div className="locations-list-item__address-city">
            {location.city}, {location.state}
          </div>
        </div>
        <div className="locations-list-item__book-now locations-list-item__book-now--info-window">
          <button
            className="btn btn--secondary book-now-btn book-now-btn btn--info-window js-book-btn"
            type="button"
            name="button"
            onClick={() => {
              handleLocationClick(location);
              analytics('Book Here', { 'Location Name': location.city }, true);
            }}
          >
            Book Now{' '}
          </button>
          {!purchaseFunnel && (
            <Link
              href={`/appointment/location/${
                location.id
              }/more-info/${slugGenerator(location.url_name)}`}
              to={`/appointment/location/${
                location.id
              }/more-info/${slugGenerator(location.url_name)}`}
              className="locations-list-item__linkout"
              target="_blank"
              onClick={() => {
                analytics('Individual Location', {
                  'Location Name': location.city,
                });
              }}
            >
              More Info
            </Link>
          )}
        </div>
      </div>
    )}
  </LocationContext.Consumer>
);

const Map = withScriptjs(
  withGoogleMap(props => {
    const options = merge(getMapOptions(), props.options);
    return (
      <GoogleMap
        defaultOptions={options}
        defaultZoom={10}
        defaultCenter={{
          lat: Number(props.locations[0].lat),
          lng: Number(props.locations[0].lang),
        }}
      >
        {props.locations.map(loc => {
          const infoWindowContent = getInfo(loc);
          return (
            <Marker
              key={loc.id}
              animation={window.google.maps.Animation.DROP}
              icon={`${Config.awsCloudFrontUrl}/svg/smiley-blue-small.svg`}
              position={{
                lat: Number(loc.lat),
                lng: Number(loc.lang),
              }}
            >
              {props.showInfoWindow && (
                <InfoWindow>{infoWindowContent}</InfoWindow>
              )}
            </Marker>
          );
        })}
      </GoogleMap>
    );
  }),
);

export default Map;
